/**
 * @flow
 * Created by neo on 05.03.17.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import Flight from '../../../Store/Flight';
import FlightRouteMap from '../../../Components/Map'

type Props = {
  params: any,
  flight: Flight,
  zoom?: number,
  center?: {
    lat: number,
    lng: number,
  },
};

@observer
export default class FlightRoute extends React.Component<Props, void> {

  render() {
    const { props: { flight: { aircraft_offer: { flight_offer: { route } } } } } = this;

    if (!route.points || route.points.length == 0) {
      // do not display map until we have route information
      return null;
    }

    return (
      <FlightRouteMap route={route} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Flight/View/FlightRoute/index.js